import { DefaultApiInstance } from "../index";

export const OrdersApi = {
  getOrders(url) {
    return DefaultApiInstance.get(url);
  },
};
